// extracted by mini-css-extract-plugin
module.exports =  {"button":"lplqoN","textDisabled":"DsLbVU","text":"aTsZu0"};